// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

export interface Position {
    top: number;
    left: number;
}

const hash = (str: string): number => {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
};

const range = (seed: number, min: number, max: number): number => {
    const fraction = (seed % 1000) / 1000;
    return min + (fraction * (max - min));
};

export const getPosition = (id: string): Position => {
    const seed = hash(id);
    return {
        top: range(seed, 15, 80),
        left: range(seed >>> 7, 8, 88),
    };
};
